
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { GameListEntityService } from '@core/services/games/gamelist-entity.service';


@Injectable()
export class GameListResolver implements Resolve<boolean> {

    constructor(private gameListEntityService: GameListEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.gameListEntityService.loaded$.pipe(
          tap(loaded =>  {
            if (!loaded) {
              this.gameListEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
